<template>
  <div class="home">
    <CurriculumPage />
  </div>
</template>

<script>
import CurriculumPage from '../components/elements/pages/CurriculumPage.vue'
export default {
  name: 'Curriculum',
  metaInfo: {
    title: 'Curriculum'
  },
  components: {
    CurriculumPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
